/* eslint-disable */
import React, { FC, ReactElement, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import withLocalization from '../../components/hoc/withLocalization';
import OfferHeader from '../../components/common/CommonOfferComponent/OfferHeader/OfferHeader';
import OfferFooter from '../../components/common/CommonOfferComponent/OfferFooter/OfferFooter';
import PackageOverview from '../../components/NewOffer/PackageOverviewPage/PackageOverview';
import OfferStep from '../../components/common/CommonOfferComponent/BreadcrumbStep/OfferStep';
import { useMediaQuery } from 'react-responsive';
import PaymentDetailsPage from '../../components/NewOffer/PaymentDetailsPage/PaymentDetailsPage';
import { RootState } from '../../redux/rootReducer';
import { logAnalyticData, offerType } from '../../analytics';
import UnifiedCheckout from '../../components/UnifiedCheckout/UnifiedCheckout';
import { RoomType } from '../newOffer/types';
import { analyticsData } from '../../analyticsTypes';
import './NewOfferPaymentDetailsContainer.scss';

import { loadScriptInHead } from '../../util/CommonLogic';
const NewOfferPaymentDetails: FC<any> = (props: any): ReactElement => {
  const isMobile = useMediaQuery({ query: `(max-width: 500px)` });
  const { localize, history } = props;
  const newOfferDetails: any = useSelector((state: RootState) => state.newOfferDetails.newOfferData);
  const isContextErr: any = useSelector((state: RootState) => state.newOfferPaymentDetails.hasPaymentContextError);
  const confirmationDetails = useSelector((state: RootState) => state.newOfferPaymentDetails.confirmationDetails);
  const isPinOptFlow: boolean = useSelector((state: RootState) => state.pinOptFlowDetails.pinOptFLow);
  const pinofferDetails: any = useSelector((state: RootState) => state.offerDetails.pinOptOfferDetails);
  const contactInfo = useSelector((state: RootState) => state.newOfferDetails.reservationContactInfo);
  const prospectDetails = useSelector((state: RootState) => state.offerDetails.prospect);
  const pinInfoDetails: any = useSelector((state: RootState) => state.pinOptFlowDetails.pinDetails);
  const billingInfo = useSelector((state: RootState) => state.newOfferPaymentDetails.billingDetailInfo);
  const newurlParams = useSelector((state: RootState) => state.newOfferDetails.urlData);
  const pinurlParams = useSelector((state: RootState) => state.pinOptFlowDetails.urlData);
  const urlParams = isPinOptFlow ? pinurlParams : newurlParams;
  const newOfferData: any = (newOfferDetails?.offers && newOfferDetails?.offers[0]) || '';
  const pinOfferData: any = (pinofferDetails?.offers && pinofferDetails?.offers[0]) || '';
  const offerData = isPinOptFlow ? pinOfferData : newOfferData;
  const title = localize('preview-sales-engine.static-content.copy.pbeo.payment-details-header');
  const locPhoneNo = (newOfferData?.offers && newOfferData?.offers[0]?.locPhoneNumber) || '';
  const pinPhNo = pinOfferData?.offerPhoneNumber || '';
  const PhoneNo = isPinOptFlow ? pinPhNo : locPhoneNo;
  const receiveOfferLoc = newOfferData.loc || '';
  const loc = offerData?.loc || '';
  const pin = pinInfoDetails?.pin || '';
  const offerDetailsInfo = isPinOptFlow ? pinOfferData : receiveOfferLoc;
  const getOfferType: any = sessionStorage.getItem('offer-type');
  const isPaid = getOfferType === 'paid' ? true : false;
  const useUnifiedCheckout = process.env.REACT_APP_USE_UNIFIED_CHECKOUT?.toLowerCase() === 'true';

  const handleLogAnalytics = (data: analyticsData) => {
    const roomType: RoomType = (offerData?.roomTypes && offerData?.roomTypes[0]) || {};
    const stateCode = roomType?.property?.stateCode;
    const flowIdentifier = isPinOptFlow ? 'pin' : isPaid ? 'paid' : 'organic';
    const destination = urlParams?.destination;
    const brand = urlParams?.brand && urlParams?.brand.length > 0 ? urlParams?.brand : roomType?.property?.brandName || '';
    const offerCode = offerData?.offerCode || 'Vacation Offer';
    if (data.googleData) {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: data.googleData.event,
        ecommerce: {
          currency: 'USD',
          value: roomType?.depositAmount?.replace(/[$,]/g, '') || '',
          ...(data.googleData.otherData?.payment_type && { payment_type: data.googleData.otherData?.payment_type }),
          items: [
            {
              item_id: roomType?.property?.marshaCode,
              item_name: roomType?.property?.name,
              item_brand: brand,
              item_category: destination,
              item_category2: loc,
              item_category3: 'USA',
              item_category4: stateCode,
              item_category5: roomType?.property?.city,
              item_category6: isPaid ? '' : contactInfo?.state ?? prospectDetails?.stateProvince,
              item_category7: offerType(offerData),
              item_category8: offerCode,
              item_category9: pin,
              price: roomType?.depositAmount?.replace(/[$,]/g, '') || '',
              retail_price: offerData?.retailValue?.replace(/[$,]/g, '') || '',
              package_price: roomType?.startingCost?.replace(/[$,]/g, '') || '',
              flow_identifier: flowIdentifier,
              quantity: 1,
            },
          ],
        },
      });
    }
    if (data.adobeData) {
      logAnalyticData(
        {
          event: data.adobeData.event,
          siteSection: 'MVC Optimized PBE',
          pageName: 'MVC | PBE Payment',
          pageHierarchy: '',
          server: 'MVC',
          website: 'MVC react',
          language: 'en',
        },
        {
          formLOC: loc, //
          destination: destination,
          resortCity: roomType?.property?.city,
          resortState: stateCode,
          resortCountry: 'USA',
          resortName: roomType?.property?.name,
          resortBrand: brand,
          offerCode: offerCode,
          offerType: offerType(offerData),
          flowIdentifier: flowIdentifier,
          retailPrice: offerData?.retailValue?.replace(/[$,]/g, '') || '',
          packagePrice: roomType?.startingCost?.replace(/[$,]/g, '') || '',
          depositPrice: roomType?.depositAmount?.replace(/[$,]/g, '') || '',
          currency: 'USD',
          quanity: '1',
          resortMarsha: roomType?.property?.marshaCode,
          userSelectedState: isPaid ? billingInfo?.state : contactInfo?.state ?? prospectDetails?.stateProvince,
          bookingStepName: data.adobeData.bookingStepName,
          ...(data.adobeData.otherData?.paymentType && { paymentType: data.adobeData.otherData?.paymentType }),
        },
      );
    }
  };

  useEffect(() => {
    if (!offerDetailsInfo) {
      history.push({
        pathname: '/error',
      });
    }
    const analyticsData: analyticsData = {
      adobeData: {
        event: 'PbeAddPaymentInformation',
        bookingStepName: 'MVC | PBE Payment',
      },
    };
    handleLogAnalytics(analyticsData);
  }, []);

  // AM-5638: PBEO- JScrambler
  useEffect(() => {
    const scriptUrl = process.env.REACT_APP_JSCRAMBLER_SCRIPT_URL;
    let scriptElement;

    if (scriptUrl) {
      loadScriptInHead(scriptUrl)
        .then((script) => {
          console.log('JSCRAMBLER Script added');
          scriptElement = script;
        })
        .catch(() => console.error('Failed to add the JSCRAMBLER script'));
    }

    // Cleanup on unmount
    return () => {
      if (scriptElement) {
        document.head.removeChild(scriptElement);
      }
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    const confirmationStatus = confirmationDetails?.status?.toLowerCase() || '';
    const ConfirmationNumber = confirmationDetails?.ConfirmationNumber || '';
    if (
      confirmationStatus === 'success' ||
      confirmationStatus === 'pending' ||
      ConfirmationNumber ||
      confirmationDetails === 'no-details-available'
    ) {
      if (isPinOptFlow) {
        const getUrlSearchParam = sessionStorage.getItem('pinOptUrlSearchParam') || '';
        history.push('/thank-you' + getUrlSearchParam);
      } else {
        const getUrlSearchParam = sessionStorage.getItem('urlSearchParam');
        history.push('/thank-you' + getUrlSearchParam);
      }

      /*  history.push({
        pathname: '/thank-you',
        search: `?loc=${receiveOfferLoc}`,
      });*/
    }
  }, [confirmationDetails]);
  return (
    <>
      <OfferHeader phone={PhoneNo} isThankyou={false} />
      <div className="tmvc-payment-main-container">
        <div className="resevre-package-container">
          {!isMobile && <OfferStep step={'2'} title={title} />}
          {!useUnifiedCheckout && <PaymentDetailsPage />}
          {useUnifiedCheckout && <UnifiedCheckout logAnalytics={handleLogAnalytics} />}
        </div>
        <PackageOverview showSummaryDetails={!useUnifiedCheckout} />
        {isMobile && <OfferStep step={'2'} title={title} />}
      </div>
      {/* <OfferFooter /> */}
    </>
  );
};
export default withRouter(withLocalization(NewOfferPaymentDetails));
